import React from 'react';
import './FooterDE.css';
import { Link } from 'react-router-dom';

const FooterDE = ({ translations }) => {
  return (
    <div className="sr-footer">
      <div>
        VERVOLLSTÄNDIGEN SIE 25 ANGEBOTE, UM EINEN ANREIZ VON 1000€ ZU ERHALTEN, ODER WENIGER, 
        UM ANREIZE MIT GERINGEREM WERT ZU ERHALTEN. VERFÜGBAR ÜBER BANKÜBERWEISUNG UND GESCHENKKARTEN.
      </div>
      <div>
        *NACH ABSCHLUSS DES KAUFS UND DER PROGRAMMANFORDERUNGEN. Handelsnamen oder Rechte, die mit 
        allen Marken auf dieser Website verbunden sind, sind Eigentum ihrer jeweiligen Inhaber und 
        nicht mit dieser Aktion verbunden.
      </div>
      <div className="footer-links">
        <Link to="/de/datenschutz" target="_blank" rel="noopener noreferrer">
          Datenschutzerklärung
        </Link>
        {' | '}
        <Link to="/de/agb" target="_blank" rel="noopener noreferrer">
          AGB
        </Link>
      </div>
      <div className="footer-copyright">
        © 2026 Rewards & Samples, LLC. Alle Rechte vorbehalten.
      </div>
    </div>
  );
};

export default FooterDE;
